export default __webpack_public_path__ + "static/media/R_wdt_c_cap_0.33094a8d.mp3";